import { graphql } from "@opensea/graphql"
import { TransferFlowReviewItemFragment } from "./TransferFlowReviewItem.fragment"

export const TransferFlowReviewItemsFragment = graphql(
  `
    fragment TransferFlowReviewItems on Item {
      id
      ...TransferFlowReviewItem
    }
  `,
  [TransferFlowReviewItemFragment],
)
